export const MESSAGE_FORM_INVALID = 'Необходимо корректно заполнить обязательные поля';

/** MESSAGES FORM ERROR */
export const MESSAGE_FORM_ERROR_UPSERT = 'При сохранении данных произошла ошибка';
export const MESSAGE_FORM_ERROR_UPDATE = 'При обновлении данных произошла ошибка';
export const MESSAGE_FORM_ERROR_DELETE = 'При удалении данных произошла ошибка';
export const MESSAGE_RECEIVE_DATA_ERROR = 'При получении данных произошла ошибка';
export const MESSAGE_RECEIVE_DATA_ERROR_WE_FIX =
  'При получении данных произошла ошибка. Мы уже работаем над её устранением';

/** MESSAGES SUCCESS */
export const MESSAGE_FORM_CREATE_SUCCESS = 'Сохранение прошло успешно';
export const MESSAGE_FORM_UPDATE_SUCCESS = 'Обновление прошло успешно';
export const MESSAGE_FORM_DELETE_SUCCESS = 'Удаление прошло успешно';
export const MESSAGE_FORM_VALIDATE_REQUIRED = 'Необходимо корректно заполнить обязательные поля!';

export const TITLE_COPY = 'Копировать';
export const TITLE_SAVE = 'Сохранить';
export const TITLE_UPDATE = 'Обновить';
export const TITLE_DELETE = 'Удалить';

export const MESSAGE_INCORRECT_SLUG =
  'Данное поле может состоять только из латинских букв в нижнем регистре, цифр и символа «_»';

export const MESSAGE_COPY = 'Копировать элемент';

export const MESSAGE_REPORT_GENERATE = `Отчет формируется. Прогресс формирования
 можете отслеживать на вкладке "Формируемые отчеты"`;
export const MESSAGE_EXPORT_GENERATE = `Выгрузка формируется. Прогресс формирования
 можете отслеживать на вкладке "Формируемые отчеты"`;
export const MESSAGE_REPORT_GENERATE_FAIL = 'При формировании отчёта произошла ошибка';
export const MESSAGE_REPORT_BACKGROUND_RESULT_HINT =
  'Результат будет на вкладке "Формируемые отчеты"';
export const MESSAGE_REPORT_DIRECT_RESULT_HINT = 'Результат будет скачан сразу';

export const ZAGS_REQUEST_FAIL_MESSAGE = 'При отправке запроса в ЗАГС произошла ошибка!';
